import React, { useState } from 'react';

import { ActionIcon, Card, Group, SegmentedControl, Stack, Text } from '@mantine/core';
import { IconClock, IconAlarm, IconX } from '@tabler/icons-react';

import Countdown from './Countdown';
import Stopwatch from './Stopwatch';

type TimerMode = 'stopwatch' | 'countdown';

interface WorkoutTimerProps {
  onClose?: () => void;
}

function WorkoutTimer({ onClose }: WorkoutTimerProps): JSX.Element {
  const [mode, setMode] = useState<TimerMode>('stopwatch');

  const handleModeChange = (next: string): void => {
    const nextMode = (next as TimerMode) || 'stopwatch';
    setMode(nextMode);
  };

  return (
    <Card withBorder radius='md' shadow='sm' sx={{ width: 300 }}>
      <Card.Section withBorder inheritPadding py='md'>
        <Group position='apart'>
          <Group spacing='xs'>
            <IconClock size={20} color='gray' />
            <Text weight={600}>{mode === 'stopwatch' ? 'Class Timer' : 'Countdown Timer'}</Text>
          </Group>

          <ActionIcon variant='subtle' color='gray' aria-label='Close timer' onClick={onClose}>
            <IconX size={20} />
          </ActionIcon>
        </Group>
      </Card.Section>

      <Card.Section inheritPadding py='md'>
        <Stack spacing='md'>
          <SegmentedControl
            fullWidth
            value={mode}
            onChange={handleModeChange}
            data={[
              {
                value: 'stopwatch',
                label: (
                  <Group>
                    <IconClock size={20} color='gray' />
                    <Text>Stopwatch</Text>
                  </Group>
                ),
              },
              {
                value: 'countdown',
                label: (
                  <Group>
                    <IconAlarm size={20} color='gray' />
                    <Text>Countdown</Text>
                  </Group>
                ),
              },
            ]}
          />

          {mode === 'countdown' && <Countdown />}
          {mode === 'stopwatch' && <Stopwatch />}
        </Stack>
      </Card.Section>
    </Card>
  );
}

export default WorkoutTimer;
